import React from 'react';

import CloseSm from '@assets/Icons/XSm';

import styles from './styles.module.scss';

export interface IBadge {
  type?: BADGE_TYPE;
  size?: BADGE_SIZE;
  children: React.ReactNode;
  onRemove?: () => void;
}

export enum BADGE_TYPE {
  DEEP_BLUE = 'deepBlue',
  DEEP_BLUE_DARK = 'deepBlueDark',
  BLUE = 'blue',
  BLUE_DARK = 'blueDark',
  LIGHT_BLUE = 'lightBlue',
  LIGHT_BLUE_DARK = 'lightBlueDark',
  SMOKE_BLUE = 'smokeBlue',
  DEEP_GREEN = 'deepGreen',
  GREEN = 'green',
  GREEN_DARK = 'greenDark',
  LIGHT_GREEN = 'lightGreen',
  PURPLE = 'purple',
  PURPLE_DARK = 'purpleDark',
  VIOLET = 'violet',
  VIOLET_LIGHT = 'violetLight',
  YELLOW = 'yellow',
  YELLOW_DARK = 'yellowDark',
  ORANGE = 'orange',
  ORANGE_DARK = 'orangeDark',
  SANDY_BROWN = 'sandyBrown',
  RED = 'red',
  RED_DARK = 'redDark',
  FUCHSIA = 'fuchsia',
  FUCHSIA_LIGHT = 'fuchsiaLight',
  BLACK = 'black',
  GREY = 'grey',
  WHITE = 'white',
  LIGHT_GREY = 'lightGrey',
  LIGHT_GREY_DARK = 'lightGreyDark',
}

export enum BADGE_SIZE {
  DEFAULT = 'default',
  SMALL = 'small',
  XSMALL = 'xsmall',
  ROUND = 'round',
}

const Badge = ({ type = BADGE_TYPE.WHITE, size = BADGE_SIZE.DEFAULT, children, onRemove }: IBadge) => {
  const handleCLick = () => {
    if (onRemove) {
      onRemove();
    }
  };

  const badgeClassName = `${styles.container} ${styles[type]} ${styles[size]} `;

  return (
    <span className={badgeClassName}>
      {children}
      {onRemove && size !== BADGE_SIZE.ROUND && (
        <button type="button" onClick={handleCLick}>
          <CloseSm size={12} />
        </button>
      )}
    </span>
  );
};

export default Badge;
